<template>
    <b-container>
        <b-row>
            <b-col>
                <br>
                      
            </b-col>
        </b-row>
        <b-row style="margin-top:20">
            <b-col style="margin-top:20">
                <h4 style="margin-top:20">Subscribe to Kegseeker Updates. Read about the freshest beers, newest breweries. Kegseeker has beers, cider, mead, kombucha.</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h5>Tell us if you are a buyer or brewer, and we will only send you relevant information</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class='col-12'>
                    <table class='table table-hover'>
                        <thead>
                            <td>
                                <h5>Please tell us a little about yourself, and enter your email below</h5>
                            </td>
                        </thead>
                        <tbody>
                            <tr v-if="!(isBrewer==0)"  style='cursor: pointer; background-color:#799bd2; color:white; font-size:35' @click="clickedIsBrewer(0)">
                                <td colspan='12'>
                                    I am looking to buy beers
                                </td>
                            </tr>
                            
                            <tr  v-if="(isBrewer==0)" style='cursor: pointer; background-color:#2e5189; color:white; font-size:35' @click="clickedIsBrewer(0)">
                                <td colspan='12'>
                                    I am looking to buy beers
                                </td>
                            </tr>

                            <tr  v-if="!(isBrewer==1)" style='cursor: pointer; background-color:#799bd2; color:white; font-size:35' @click="clickedIsBrewer(1)">
                                <td colspan='12' style="margin-bottom:10px">
                                    <div>I am a Brewer and I would like to sell my beer</div>
                                </td>
                            </tr>
                            <tr v-if="(isBrewer==1)" style='cursor: pointer; background-color:#2e5189; color:white; font-size:35' @click="clickedIsBrewer(1)">
                                <td colspan='12' style="margin-bottom:10px">
                                    <div>I am a Brewer and I would like to sell my beer</div>
                                </td>
                            </tr>

                            <tr  v-if="!(isBrewer==2)" style='cursor: pointer; background-color:#799bd2; color:white; font-size:35' @click="clickedIsBrewer(2)">
                                <td colspan='12' style="margin-bottom:10px">
                                    <div>I am a Beer Distributor</div>
                                </td>
                            </tr>
                            <tr v-if="(isBrewer==2)" style='cursor: pointer; background-color:#2e5189; color:white; font-size:35' @click="clickedIsBrewer(2)">
                                <td colspan='12' style="margin-bottom:10px">
                                    <div>I am a Beer Distributor</div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div style="width:400">
                    <b-form-group
                    id="fieldset-4"
                    label="Email"
                    label-for="input-5"
                    :invalid-feedback="invalidEmail"
                    :state="checkEmailValid"
                    >
                    <b-form-input id="input-5" v-model="email" trim></b-form-input>
                    </b-form-group>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button class="btn btn-success" type="submit" :disabled="!checkEmailValid" @click="addEmail()">Sign Up</b-button>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    const fb = require('../firebaseConfig.js')
    export default {
        components: {
        },

        data() {
            return {
                email:"",
                isBrewer:-20,
                emailWarning:true,
                invalidEmail:'',
            }
        },
        computed:{
            checkEmailValid(){
                 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.email))
                    {
                        return (true)
                    }
                        return (false)
            },
        },

        methods: {
            clickedIsBrewer(brewerVal){
                this.isBrewer=parseInt(brewerVal)
            },

            addEmail(){
                if (this.checkEmailValid) 
                    this.invalidEmail=""
                else {
                    this.invalidEmail= 'Please check the email address'
                    return
                }
                var user = {email:this.email, isbrewer:this.isBrewer}

                fb.emailsCollection.add(user).then(() => {
                            this.showSuccess = true
                            this.$bvToast.toast('Thank you for subscribing', {
                            title: 'Subscribed!',
                            solid:true,
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: false
                            })
                        this.email=""
                    })
            },
        
        }
    }
</script>

<style scoped>
.modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
}

.test-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}

.selected{
    cursor: pointer;
    background-color: #5cb85c;
}